export const ADD = "ADD";
export const EDIT = "EDIT";
export const ADDBRANDFILTER = "ADDBRANDFILTER";
export const ADDGENDERFILTER = "ADDGENDERFILTER";
export const SET_PRODUCT_CLICKED = "SETPRODUCTCLICKED"
export const SET_ADDRESS = "SETADDRESS";
export const DECREASEPRODUCTCOUNT = "DECREASEPRODUCTCOUNT";
export const DELETECARTPRODUCT = "DELETECARTPRODUCT";
export const INCREASECARTPRODUCTCOUNT = "INCREASECARTPRODUCTCOUNT";
export const ADDUSER = "ADDUSER";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const PERCENTFILTER = "PERCENTFILTER";